import { render, staticRenderFns } from "./StaticManager.vue?vue&type=template&id=271bf35b&"
import script from "./StaticManager.vue?vue&type=script&lang=js&"
export * from "./StaticManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports